import { ApplicationTypes, KickPlateCountersinkHoles, attachComponent, featureLabels } from 'metalworks-domain'

import { detailComponent, entityHeaderComponent, propertyPageComponent } from '@salsita-ai/platform-project-sdk/domain'
import { DeleteEntityButton, ReplaceEntityDropdown } from '@salsita-ai/platform-project-sdk/react'

import { KickPlateCountersinkHolePropertyPage } from '../ui/property-pages/KickPlateCountersinkHolePropertyPage'

export const kickPlateCountersinkHoleComponents = [
  attachComponent
    // TODO: yaml
    .withComponent(detailComponent, 'main')
    .withEntity('KickPlateCountersinkHoles')
    .attach(self => {
      return {
        title: featureLabels[KickPlateCountersinkHoles.type],
        subtitle:
          self.topRadius > 0
            ? `Ø\u00a0${self.topRadius * 2}mm, 90°\u00a0countersink, Ø\u00a0${self.bottomRadius * 2}mm through`
            : `There's no countersink hole type available for currently selected plate.`,
        description: 'Countersink holes for horizontal edges of the plate.',
        thumbnailUrl: '/thumbnails/countersink-hole.png',
      }
    }),
  attachComponent
    .withComponent(propertyPageComponent, 'box')
    .withEntity('KickPlateCountersinkHoles')
    .withFilter({
      navigationStates: [ApplicationTypes.NavigationState.Features, ApplicationTypes.NavigationState.FeatureList],
    })
    // TODO: memoEval
    .attach(s => ({
      page: <KickPlateCountersinkHolePropertyPage id={s.id} />,
    })),
  attachComponent
    .withComponent(entityHeaderComponent, 'main')
    .withEntity('KickPlateCountersinkHoles')
    .withFilter({
      navigationStates: [ApplicationTypes.NavigationState.Features, ApplicationTypes.NavigationState.FeatureList],
    })
    // TODO: memoEval
    .attach(s => ({
      // TODO: this now needs separate replace entity component
      primaryButton: <ReplaceEntityDropdown entityId={s.id} />,
      secondaryButton: <DeleteEntityButton entityId={s.id} />,
    })),
]
